export default __webpack_public_path__ + "static/media/i-exterior - bcr.4386f3ac.svg";